import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const styles = {
  otpGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  otpInput: {
    width: '50px',
    height: '50px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    margin: '10px',
    textAlign: 'center',
    fontSize: '32px',
    fontWeight: 'bold',
    lineHeight: '1'
  }
};

export const OtpInput = ({ value, onChange }) => {

  const RE_ALPHANUMERIC = new RegExp(/^\w+$/);

  const valueItems = useMemo(() => value.split(''), [value]);

  const focusToNextInput = (target) => {
    const nextElementSibling =
      target.nextElementSibling;

    if (nextElementSibling) {
      nextElementSibling.focus();
    }
  };

  const focusToPrevInput = (target) => {
    const previousElementSibling =
      target.previousElementSibling;

    if (previousElementSibling) {
      previousElementSibling.focus();
    }
  };

  const inputOnChange = (e, idx) => {
    const target = e.target;
    let targetValue = target.value.trim();
    const isTargetValue = RE_ALPHANUMERIC.test(targetValue);

    targetValue = isTargetValue ? targetValue : ' ';

    const targetValueLength = targetValue.length;

    if (targetValueLength === 1) {
      const newValue = value.substring(0, idx) + targetValue + value.substring(idx + 1);
      onChange(newValue);
      focusToNextInput(target);
    } else if (targetValueLength === value.length) {
      onChange(targetValue);
      target.blur();
    }

    return '';
  };

  const inputOnKeyDown = (e) => {
    const { key, target } = e;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      e.preventDefault();
      return focusToNextInput(target);
    }

    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      e.preventDefault();
      return focusToPrevInput(target);
    }

    const targetValue = target.value;

    target.setSelectionRange(0, targetValue.length);

    if (key !== 'Backspace' || targetValue !== '') {
      return '';
    }

    return focusToPrevInput(target);
  };

  const inputOnFocus = (e) => {
    const { target } = e;

    const prevInputEl =
      target.previousElementSibling;

    if (prevInputEl && prevInputEl.value === '') {
      return prevInputEl.focus();
    }

    return target.setSelectionRange(0, target.value.length);
  };

  return (
    <div style={styles.otpGroup}>
      {valueItems.map((digit, idx) => (
        <input
          style={styles.otpInput}
          key={idx}
          type='text'
          maxLength='1'
          value={digit}
          onChange={(e) => inputOnChange(e, idx)}
          onKeyDown={inputOnKeyDown}
          onFocus={inputOnFocus}
        />
      ))}
    </div>
  );
};

OtpInput.propTypes = {
  value: PropTypes.string,
  valueLength: PropTypes.number,
  onChange: PropTypes.func
};